const fmtOrderDate = (orderDate) => {
  if (!orderDate) return '';
  const [y, m, d] = orderDate.split('-').map(Number);
  if (!y || !m || !d) return '';
  return new Date(y, m - 1, d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
};

export function formatOrderRef(order) {
  const num = order?.orderNumber;
  if (num != null && Number.isFinite(Number(num))) {
    const dateLabel = fmtOrderDate(order.orderDate);
    return dateLabel ? `#${num} · ${dateLabel}` : `#${num}`;
  }
  return order?.id ? `#${String(order.id).slice(0, 8)}` : '#—';
}

export function formatOrderTitle(order) {
  const num = order?.orderNumber;
  if (num != null && Number.isFinite(Number(num))) {
    return `Order #${num}`;
  }
  return order?.id ? `Order #${String(order.id).slice(0, 8)}` : 'Order';
}
